import type { FC } from 'react';
import {
  BiData,
  BiContextProvidedValue,
  ItemClickBiEvent,
} from '@wix/da-bi/pkg/events';
import { useMeasureElementCookie } from '@wix/da-hooks/pkg/useMeasureElement/useMeasureElementCookie';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';
import { gallectionTypeToResourceType } from '@wix/da-shared-react/pkg/types/gallection';
import OnScrollBottom, {
  DISTANCE_UNIT,
} from '@wix/da-shared-react/pkg/OnScrollBottom';
import CreateFolderCard from '../../_partials/CreateFolderCard';
import FolderCard from '../../_partials/FolderCard';
import { Props, THUMB_WIDTH, THUMB_HEIGHT } from './FolderListDesktop';

import s from './FolderListMobile.scss';

const THUMB_GAP = 16;

// Wrapper to decouple the measure hook from the desktop version
const FolderListMobile: FC<Props> = ({
  visibleSubfolders,
  withCreateButton,
  withFolderActions,
  hasMoreSubfolders,
  isBusy,
  fetchMoreSubfolders,
}) => {
  const { ref, dimensions: measuredContainer } = useMeasureElementCookie(
    MeasuredCookieType.STASH_FOLDER_CARD,
    { cookieDim: 'width' }
  );

  const thumbWidth = measuredContainer?.width
    ? (measuredContainer.width - THUMB_GAP) / 2
    : THUMB_WIDTH;

  return (
    <div className={s['root']} ref={ref}>
      <div className={s['expanded-grid']}>
        {withCreateButton && (
          <CreateFolderCard
            width={thumbWidth}
            height={THUMB_HEIGHT}
            folderType="stash"
          />
        )}
        {visibleSubfolders.map(folder => (
          <FolderCard
            key={`folder-${folder.folderId}`}
            folder={folder}
            width={thumbWidth}
            height={THUMB_HEIGHT}
            withActions={withFolderActions}
            biData={BiData<ItemClickBiEvent>({
              evid: 100,
              view: BiContextProvidedValue,
              component: BiContextProvidedValue,
              page_typeid: BiContextProvidedValue,
              page_itemid: BiContextProvidedValue,
              sectionname: BiContextProvidedValue,
              typeid: gallectionTypeToResourceType(folder?.type || 'stash'),
              itemid: folder?.folderId,
            })}
          />
        ))}
      </div>

      {hasMoreSubfolders && !isBusy ? (
        <OnScrollBottom
          checkOnMount
          checkOnUpdate={hasMoreSubfolders}
          onScrolledToBottom={() => fetchMoreSubfolders()}
          distanceToBottom={100}
          distanceUnit={DISTANCE_UNIT.PX}
        />
      ) : null}
    </div>
  );
};
FolderListMobile.displayName = 'FolderListMobile';

export default FolderListMobile;
